import { baseApi } from './baseApi';

const URL_SEQUENCE = 'sequences';

interface GenerateCodeRequest {
  code: string;
}

const sequenceApiService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    generateCode: builder.mutation<string, GenerateCodeRequest>({
      query: (data) => ({
        url: URL_SEQUENCE,
        method: 'POST',
        data,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGenerateCodeMutation } = sequenceApiService;
